export default __webpack_public_path__ + "images/Tapclicks.48ca1dd51130c6a44bef56b14556aa1f.svg";